import React from 'react'

const Home = () => {
  return (
    <>
        <div className='container has-text-centered'>
        <span className="icon is-large has-text-info">
          <i className="fas fa-spinner fa-2x fa-pulse"></i>
        </span>
        </div>
    </>
  )
}

export default Home
